import globalStyles from "../../../../../../../../../assets/styles/base/globalPage.module.scss";
import secondaryComponents from "../../../../../../../../../components/secondaryComponents";
import useScheduleDelivery from "./useSheduleDeliveryForm";
import primaryComponents from "../../../../../../../../../components/primaryComponents";
import useScheduleValidation from "./useValidation";

const SheduleDeliveryForm = ({ closeModal = () => {} }) => {
  const {
    scheduleData,
    setScheduleData,
    toggleItem,
    toggleAll,
    someSelected,
    allSelected,
    selected,
    isLoadingScheduleDelivery,
    handleUpdateScheduleDelivery,
    updateScheduleDelivery,
    updateScheduleField,
  } = useScheduleDelivery({ closeModal });
  const {
    control,
    handleSubmit,
    formState: { errors },
    register,
    trigger,
    setValue,
    clearErrors,
    watch,
  } = useScheduleValidation({ scheduleData });
  return (
    <>
      <secondaryComponents.LoaderHelper
        isLoading={isLoadingScheduleDelivery}
        classNames={"mt-5"}
      >
        <div className={`${globalStyles.tableWrapper}`}>
          <div className={globalStyles.tableHeader}>
            <p>Configure Your Scheduled Delivery</p>
          </div>
          <secondaryComponents.SheduleDeliveryTable
            control={control}
            register={register}
            clearErrors={clearErrors}
            watch={watch}
            setValue={setValue}
            trigger={trigger}
            errors={errors}
            items={scheduleData}
            toggleAll={toggleAll}
            toggleItem={toggleItem}
            someSelected={someSelected}
            allSelected={allSelected}
            selected={selected}
            setScheduleData={setScheduleData}
            updateScheduleField={updateScheduleField}
          />
        </div>
        <div className={`${globalStyles.stickyBottomCover}`}>
          <primaryComponents.Button
            classNames={"btn btn--primary w-100"}
            type="button"
            isDisabled={updateScheduleDelivery.isLoading}
            isLoading={updateScheduleDelivery.isLoading}
            onClick={handleSubmit(handleUpdateScheduleDelivery)}
          >
            Save
          </primaryComponents.Button>
        </div>
      </secondaryComponents.LoaderHelper>
    </>
  );
};

export default SheduleDeliveryForm;
